import { ButtonPresentationProps } from "@insite/mobius/Button";
import { ClickablePresentationProps } from "@insite/mobius/Clickable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

export const carouselMainContainer: GridContainerProps = {
    gap: 0,
    css: css`
        position: relative;
    `,
};

const baseArrowGridItem = css`
    position: absolute;
    top: 50%;
    z-index: 2;
    width: auto;
    max-width: none;
    flex-basis: auto;
`;

export const carouselPrevArrowGridItem: GridItemProps = {
    width: 1,
    align: "middle",
    css: css`
        ${baseArrowGridItem}
        left: 0;
        transform: translate(-4px, -50%);
    `,
};

export const carouselNextArrowGridItem: GridItemProps = {
    width: 1,
    align: "middle",
    css: css`
        ${baseArrowGridItem}
        right: 0;
        transform: translate(4px, -50%);
    `,
};

export const carouselGridItem: GridItemProps = {
    width: 12,
    css: css`
        flex-basis: 100%;
        max-width: 100%;
    `,
};

export const carouselWrapper: InjectableCss = {
    css: css`
        width: 100%;
        position: relative;
    `,
};

export const carouselContainer: InjectableCss = {
    css: css`
        overflow: hidden;
    `,
};

export const carouselSlidesContainer: InjectableCss = {
    css: css`
        display: flex;
    `,
};

export const carouselSlide: InjectableCss = {
    css: css`
        padding: 0 8px;
        position: relative;
        flex: 0 0 auto;
        box-sizing: border-box;
    `,
};

const baseArrowButton = css`
    width: 48px;
    height: 48px;
    padding: 0;
    border: ${({ theme }: { theme: BaseTheme }) => theme.colors.primary.main} solid 1px;
    border-radius: 100%;
    background-color: ${({ theme }: { theme: BaseTheme }) => theme.colors.primary.main};
    transition: 0.3s;

    &:hover {
        background-color: ${({ theme }: { theme: BaseTheme }) => theme.colors.primary.contrast};
        border-color: ${({ theme }: { theme: BaseTheme }) => theme.colors.primary.main} !important;
    }

    &:disabled {
        opacity: 0.4;
        pointer-events: none;
    }
`;

export const carouselPrevArrowButton: ButtonPresentationProps = {
    variant: "secondary",
    color: "primary.contrast",
    css: baseArrowButton,
};

export const carouselNextArrowButton: ButtonPresentationProps = {
    variant: "secondary",
    color: "primary.contrast",
    css: baseArrowButton,
};

export const carouselDotsContainer: InjectableCss = {
    css: css`
        display: flex;
        justify-content: center;
        gap: 12px;
        margin-top: 30px;
    `,
};

const baseDot = css`
    width: 8px;
    height: 8px;
    border-radius: 100%;
    border: 0;
    padding: 0;
    cursor: pointer;
    transition: 0.5s;
`;

export const carouselDot: ClickablePresentationProps = {
    css: css`
        ${baseDot}
        background-color: ${({ theme }: { theme: BaseTheme }) => theme.colors.common.disabled};

        &:hover {
            background-color: ${({ theme }: { theme: BaseTheme }) => theme.colors.primary.main};
        }
    `,
};

export const carouselDotActive: ClickablePresentationProps = {
    css: css`
        ${baseDot}
        background-color: ${({ theme }: { theme: BaseTheme }) => theme.colors.primary.main};
        width: 32px;
        border-radius: 0;
    `,
};
